import { render, staticRenderFns } from "./ReportingLayout.vue?vue&type=template&id=33ec2fbd"
import script from "./ReportingLayout.vue?vue&type=script&lang=js"
export * from "./ReportingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports